import { Component, OnInit } from '@angular/core';
//import { Hero } from '../hero';
import { Page } from '../page';
import { Chapter } from '../chapter';
//import { HeroService } from '../hero.service';
import { PageService } from '../page.service';
//import { PAGES } from '../mock-pages';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.css' ]
})
export class DashboardComponent implements OnInit {
  //pages: Page[] = [];
  chapters: Chapter[] = [];
  bookimg_uri: string = '';
  
  constructor(private pageService: PageService) { 
	this.bookimg_uri = 'http://www.jsd.or.kr/pages/docs/cscs/assets/cscs_book.jpg'; 
  }

  ngOnInit() {
    //this.getPages();
    this.getChapters();
	//this.pages = PAGES;
	//console.log(this.pages);
  }

  getPages(): void {
    //this.pageService.getPages(0)
    //  .subscribe(pages => this.pages = pages.slice(1, 50));
  }
  
  getChapters(): void {
	this.pageService.getChapters() 
	  .subscribe(chapters => this.chapters = chapters);
  }
}
